import { QueryOptions, useQuery } from '@tanstack/react-query';

import { QueryKey } from ':cloud/queries/types';
import { useGetUser } from ':cloud/queries/UserQueries/useGetUser';
import { APIClientBase } from ':cloud/state/Api';
import { ProjectInvite } from ':cloud/types/service_proto';

interface ListUserInvitesResponse {
  invites: any[];
  legacyResponse: any[];
  projectsInvites: ProjectInvite[];
}

async function fetchProjectInvites(): Promise<ListUserInvitesResponse> {
  const path = `/organization-management/v1/customers/invites`;
  const { data } = await APIClientBase.get<ListUserInvitesResponse>(path);

  return data;
}

function generateProjectInvitesQuery(userId: string) {
  return {
    queryKey: [QueryKey.self, 'project-invites', userId],
    queryFn: async () => fetchProjectInvites(),
    enabled: !!userId,
    refetchOnWindowFocus: true,
    select: (data: ListUserInvitesResponse) =>
      data.projectsInvites?.filter((item) => !item.accepted),
  };
}

export function useGetProjectInvites(): {
  data: ProjectInvite[];
  isLoading: boolean;
} {
  const { user } = useGetUser();

  const query: QueryOptions = generateProjectInvitesQuery(user.userId);

  const { isLoading, data } = useQuery({ ...query });

  return {
    data: (data as ProjectInvite[]) ?? [],
    isLoading,
  };
}
